export const CHECKOUT_DATA = 'checkoutData';
export const ADDRESS = 'address';
